import axios from "axios";
import * as actionType from "../../constant/actionType";
export const AssignClientToWorkerByProvider = (ApiData) => async (dispatch) => {
      try {
        const response = await axios({
          method: 'post',
          data: ApiData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
          },
          url: `${actionType.environment_url}/api/admin/worker/AssignClientToWorkerByProvider`,
        });
        return response.data
      } catch (error) {
        return  error.message
      }
    }